import { appConfig } from 'src/app/app-config';

export const getYearsFromConfigStartYear = () =>
    Array.from(Array(12).keys()).map((year) => year + appConfig.moveIn.calendarFromYear);
